import { React, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";

import { Header, LoadingSpinner } from "../../Shared";
import { SubjectAccordion } from "./";
import { ComparisonNames, FilterComparisonMain, FilterNames, CheckAppliedFilter } from "../";
import { Common } from "../../../helper";

import "../../../assets/stlyes/BigPicture/EOYP.scss";

const ProgressGraph = () => {
  const [comparisonGroup, setComparisonGroup] = useState();
  const [subjects, setSubjects] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [generateReport, setGenerateReport] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState([]);
  const [selectedComparision, setSelectedComparision] = useState();
  const [selectedClassName, setSelectedClassName_] = useState();
  const [selectedBaseLine, setSelectedBaseLine] = useState(Common.GLD);
  const [ksDisable, setKsDisable] = useState(false);
  const [previousDisable, setPreviousDisable] = useState(false);
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(null);

  let pupilProgress = useSelector((state) => state.pupilProgress.pupilFilter.info)
  pupilProgress = { ...pupilProgress, baseline: selectedBaseLine };
  const compSelected = useSelector((state) => state.pupilProgress.BPComparisonSelect);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)

  const getProgress = (progress) => {
    setSubjects(progress)
    setGenerateReport(true)
    setIsLoading(false)
  }

  const handleRadioChange = (event) => {
    setSelectedBaseLine(event.target.value);
  };

  const setSelectedClassName = (e) => {
    setSelectedClassName_(e)
  }

  const disableKSResult = () => {
    setKsDisable(pupilProgress.pupilYear.length === 1 ? [1, 2].includes(pupilProgress.pupilYear[0]) : pupilProgress.pupilYear.length === 2 ? pupilProgress.pupilYear[0] === 1 && pupilProgress.pupilYear[1] === 2 : false);
    setPreviousDisable(pupilProgress.pupilYear.length === 1 ? pupilProgress.pupilYear[0] === 1 : false);
  }

  useEffect(() => {
    disableKSResult()
  }, [pupilProgress])

  useEffect(() => {
    setComparisonGroup(Common.AllGroups)
    CheckAppliedFilter(setSelectedComparision, compSelected, setSelectedFilter, selectedClassName, pupilProgress);
  }, [subjects])

  // New useEffect to handle radio button changes
  useEffect(() => {
    // Check if the KS1 or Previous radio button is checked and disabled
    if ((selectedBaseLine === Common.KsResult_ && ksDisable) || (selectedBaseLine === Common.PreviousYear_ && previousDisable)) {
      // If so, set the base line to GLD
      setSelectedBaseLine(Common.GLD);
    }
  }, [ksDisable, previousDisable, selectedBaseLine]);

  const toggleAccordion = (index) => setActiveAccordionIndex(activeAccordionIndex === index ? null : index);

  return (
    <div className="bigPictureEOYP">
      <div className="Page-layout">
        <div className="Page-header">
          <Header />
          <div className="Page-body" style={{ paddingRight: !isNavCollapsed ? "250px" : "75px" }}>
            <div className="EOYP-header">
              <div className="Page-name">
                <span className="EOYP-name-firstText">{Common.BigPicturePageName}</span>
                <span className="EOYP-name-secondText">{Common.EndOfYearPredictions}</span>
              </div>
              <div className="EOYP-title">
                <span className="EOYP-titleText">{Common.Progress}</span>
              </div>
              <div className="EOYP-subtitle">
                <span className="EOYP-subtitleText">{Common.pupilProgressAgainstBaseLine}</span>
              </div>
            </div>
            <div className="EOYP-comparison">
              <FilterComparisonMain setSubjects={getProgress} number={5} setIsLoading={setIsLoading} isGLD={false} setSelectedClassName={setSelectedClassName} selectedBaseLine={selectedBaseLine} isSubject={true} />
            </div>
            <div>
              {
                isLoading ? <LoadingSpinner /> : (generateReport ? (<Row style={{ marginTop: "20px" }}>
                  <Col sm={12}>
                    <div className="bigPictureDataView-EOYP">
                      <Row>
                        <Col sm={8}>
                          <div className="title">
                            <span className="dataView-title">{`${Common.Progress}: `}</span>
                            <span className="dataView-title">{comparisonGroup}</span>
                          </div>
                          <div className="subtitles1">
                            <span className="dataView-subtitle">{`${Common.Comparison}: `}</span>
                            <span className="dataView-subtitle2">{ComparisonNames(selectedComparision)}</span>
                          </div>
                          <div className="subtitles2">
                            <span className="dataView-subtitle">{`${Common.AppliedFilters}: `}</span>
                            <span className="dataView-subtitle2">{selectedFilter && FilterNames(selectedFilter)}</span>
                          </div>
                        </Col>
                        <Col sm={3} className="baseLine">
                          <span className="label">{Common.BaseLine}</span>&nbsp;
                          <div className="subtitles3">
                            <form className="dataView-radio">
                              <div><input type="radio" id={Common.GLD} checked={selectedBaseLine === Common.GLD} value={Common.GLD} onChange={handleRadioChange} style={{ accentColor: selectedBaseLine === Common.GLD ? "" : "transparent", cursor: "pointer" }} />
                                <label className="label_" htmlFor={Common.GLD}>{Common.GLD}</label></div>&nbsp;
                              <div><input type="radio" id="KS1" checked={selectedBaseLine === Common.KsResult_} value={Common.KsResult_} onChange={handleRadioChange} style={{ accentColor: selectedBaseLine === Common.KsResult_ ? "" : "transparent", cursor: "pointer" }} disabled={ksDisable} />
                                <label className="label_" htmlFor="KS1" >{Common.KS1}</label></div>&nbsp;
                              <div><input type="radio" id="Previous" checked={selectedBaseLine === Common.PreviousYear_} value={Common.PreviousYear_} onChange={handleRadioChange} style={{ accentColor: selectedBaseLine === Common.PreviousYear_ ? "" : "transparent", cursor: "pointer" }} disabled={previousDisable} />
                                <label className="label_" htmlFor="Previous" >{Common.LastYear}</label></div>&nbsp;
                            </form>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          {subjects && subjects.map((sub, i) => (<SubjectAccordion subject={sub} key={i} index={i} toggleAccordion={toggleAccordion} activeAccordionIndex={activeAccordionIndex} />))}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>) : "")
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ProgressGraph }